import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=08ea9870&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=ts&"
export * from "./ActivityDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea9870",
  null
  
)

export default component.exports